var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditColorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.32343 1.10645H3.35649C2.10897 1.10645 1.09766 2.131 1.09766 3.39486V18.6051C1.09766 19.869 2.10897 20.8935 3.35649 20.8935H7.32343C8.57095 20.8935 9.58226 19.869 9.58226 18.6051V3.39486C9.58226 2.131 8.57095 1.10645 7.32343 1.10645Z",
    stroke: "#538FFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7662 1.83423L14.4378 3.33827C15.5952 3.81536 16.1539 5.14959 15.691 6.3221L10.0718 20.4164C9.99999 20.5862 9.91219 20.748 9.81641 20.8935",
    stroke: "#538FFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8288 5.78833L20.2074 8.10908C21.1093 8.99049 21.1333 10.4379 20.2633 11.3517L11.1641 20.8935",
    stroke: "#538FFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4323 13.6562C20.5601 13.9393 20.6319 14.2627 20.6319 14.5943V18.605C20.6319 19.8746 19.6182 20.8934 18.3731 20.8934H3.35938",
    stroke: "#538FFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21069 18.6697C5.81461 18.6697 6.30419 18.1737 6.30419 17.5619C6.30419 16.9501 5.81461 16.4541 5.21069 16.4541C4.60676 16.4541 4.11719 16.9501 4.11719 17.5619C4.11719 18.1737 4.60676 18.6697 5.21069 18.6697Z",
    fill: "#538FFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditColorIcon);
export default __webpack_public_path__ + "static/media/EditColorIcon.89943655.svg";
export { ForwardRef as ReactComponent };